
import styles from "../AccountingPage.module.scss";
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import Notification from "utils/Notifications";
import { Button } from 'components'
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { getExpensesData, PostExpensesData, DeleteExpensesData, PatchExpensesData, DeleteFileData } from "service/AccountingService";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import ExpensesOrder from "./components/ExpensesOrder"
import { Icon } from '../../../components/UnvUI/Icons'

const ExpensesContent = ({ render, setRender, datacheck, id }) => {
  const { t } = useTranslation('common')

    const componentRef = useRef();
    const [openModal, setOpenModal] = useState(false);
    const [openModalOrder, setOpenModalOrder] = useState(false);
    const [item_data, setItemData] = useState([]);

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const setOpenModalOrderFun = (item) => {
        setOpenModalOrder(true);
        setItemData(item);
    };
    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });
    const [data, setData] = useState([]);
    const getData = async (id) => {
        try {
            let response = await getExpensesData(id, data);
            setData(response.data);

        } catch (error) {
        }
    };
    const [amount, setAmount] = useState("");
    const [recipient, setRecipient] = useState("");
    const [order, setOrder] = useState("");
    const [date, setDate] = useState("");
    const [description, setDescription] = useState("");
    const [files_data, setFiles] = useState(null);

    const onFileChange = (event) => {
        setFiles(event.target.files);

    };

    const [selectedCheckId, setCheckID] = useState("");

    const handleSelectCheckById = (id) => {
        setCheckID(id);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!amount) {
            setNotify({
                isOpen: true,
                message: "Введите сумму Расхода!",
                type: "error",
            });

        }

        else if (!selectedCheckId) {
            setNotify({
                isOpen: true,
                message: "Выберите основание Расхода!",
                type: "error",
            });

        }
        else if (!recipient) {
            setNotify({
                isOpen: true,
                message: "Введите получателя!",
                type: "error",
            });

        }
        else if (!order) {
            setNotify({
                isOpen: true,
                message: "Введите номер расходного ордера!",
                type: "error",
            });

        }
        else if (!date) {
            setNotify({
                isOpen: true,
                message: "Введите дату Расхода!",
                type: "error",
            });

        }
        else {
            const formData = new FormData();
            formData.append('amount', amount);
            formData.append('order', order);
            formData.append('recipient', recipient);
            formData.append('date', date);
            formData.append('checkmodel', selectedCheckId);
            formData.append('description', description);
            if (files_data && files_data.length > 0) {
                for (let i = 0; i < files_data.length; i++) {
                    formData.append('files', files_data[i]);
                }
            }
            let data = await PostExpensesData(id, formData);

            getData();

            setAmount("");
            setDate("");
            setDescription("");
            setFiles(null)
            setOpenModal(false)
            setCheckID("");
            setOrder("");
            setRecipient("");
            setNotify({
                isOpen: true,
                message: "Расход успешно создан!",
                type: "success",
                sound: "success"
            });
            setRender(true)
        }

    };

    useEffect(() => {

        getData(id);

        setRender(false);


    }, [render]);


    const [searchAmount, setSearchAmount] = useState('');
    const [searchRecipient, setSearchRecipient] = useState('');

    const [searchDescription, setSearchDescription] = useState('');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [searchCheck, setSearchCheck] = useState("");
    const [searchOrder, setSearchOrder] = useState('');
    const setSearchCheckById = (id) => {
        setSearchCheck(id);
    };
    function convertToISO(dateStr) {
        const [day, month, year] = dateStr.split('.');
        return `${year}-${month}-${day}`;
    }
    const [searchBase, setSearchBase] = useState('');
    const filteredData = Array.isArray(data)
        ? data.filter((item) => {
            const matchAmount = item.amount?.toString().includes(searchAmount);
            const matchDescription = item.description
                ?.toLowerCase()
                .includes(searchDescription.toLowerCase());

            const matchCheck = !searchCheck || item.checkmodel === Number(searchCheck);

            const itemDateISO = convertToISO(item.date); 

            const matchOrder = item.order
                ?.toLowerCase()
                .includes(searchOrder.toLowerCase());

            const matchRecipient = item.recipient
                ?.toLowerCase()
                .includes(searchRecipient.toLowerCase());

            const fromOk = !dateFrom || itemDateISO >= dateFrom;
            const toOk = !dateTo || itemDateISO <= dateTo;

            return (
                matchOrder &&
                matchRecipient &&
                matchCheck &&
                matchAmount &&
                matchDescription &&
                fromOk &&
                toOk
            );
        })
        : [];


    const clearFilters = () => {
        setSearchAmount('');
        setSearchDescription('');
        setDateFrom('');
        setDateTo('');
        setSearchCheck('');
        setSearchBase('');
        
        setSearchCheckData("");
        setSearchOrder('');
        setSearchRecipient('');
        setCurrentPage(1); 
    };


    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalAmount = currentItems
        .reduce((sum, item) => sum + Number(item.amount), 0)
        .toFixed(2);


    const [editRowId, setEditRowId_Set] = useState(null);
    const [amount_edit, setAmountEdit] = useState('');
    const [recipient_edit, setRecipientEdit] = useState('');
    const [order_edit, setOrderEdit] = useState('');
    const [description_edit, setDescriptionEdit] = useState('');
    const [date_edit, setDateEdit] = useState('');
    const [files_data_edit, setFilesDataEdit] = useState([]);
    const [selectedCheckId_edit, setCheckID_edit] = useState("");

    const handleSelectCheckByIdEdit = (id) => {
        setCheckID(id);
    };

    const [searchCheck_editnew, setSearchCheck_editnew] = useState('');
    const [searchBase_editnew, setSearchBase_editnew] = useState('');

    const handleCheckInput_editnew = (value) => {
        setSearchCheck_editnew(value);

        const matchedItem = datacheck.find(item =>
            item.check_data.toLowerCase() === value.toLowerCase()
        );

        if (matchedItem) {
            handleSelectCheckByIdEdit(matchedItem.id);
            setSearchBase_editnew(matchedItem.base); 
        } else {
            handleSelectCheckByIdEdit('');
        }
    };

    const handleBaseInput_editnew = (value) => {
        setSearchBase_editnew(value);

        const matchedItem = datacheck.find(item =>
            item.base.toLowerCase() === value.toLowerCase()
        );

        if (matchedItem) {
            handleSelectCheckByIdEdit(matchedItem.id);
            setSearchCheck_editnew(matchedItem.check_data); 
        } else {
            handleSelectCheckByIdEdit('');
        }
    };

    const filteredChecks_editnew = datacheck?.filter(item =>
        item.check_data.toLowerCase().includes(searchCheck_editnew.toLowerCase())
    );

    const filteredBases_editnew = datacheck?.filter(item =>
        item.base.toLowerCase().includes(searchBase_editnew.toLowerCase())
    );

    const setEditRowId = (item) => {
        setAmountEdit(item.amount)
        handleSelectCheckByIdEdit(item.checkmodel)
        setRecipientEdit(item.recipient)
        setOrderEdit(item.order)
        setDescriptionEdit(item.description)
        setFilesDataEdit([])
        setDateEdit('')
        setEditRowId_Set(item.id)
    };

    const onFileChangeEdit = (e) => {
        setFilesDataEdit([...e.target.files]);
    };
    const onDelete = async (id) => {
        let data = await DeleteExpensesData(id);
        setNotify({
            isOpen: true,
            message: "Расход успешно удалено!",
            type: "success",
            sound: "success"
        });
        setRender(true)
    };

    const onSave = async (id) => {
        const formData = new FormData();
        formData.append('amount', amount_edit);
        formData.append('recipient', recipient_edit);
        formData.append('checkmodel', selectedCheckId_edit);
        formData.append('order', order_edit);
        if (date_edit) {
            formData.append('date', date_edit);
        }
        formData.append('description', description_edit);
        if (files_data_edit && files_data_edit.length > 0) {
            for (let i = 0; i < files_data_edit.length; i++) {
                formData.append('files', files_data_edit[i]);
            }
        }
        let data = await PatchExpensesData(id, formData);


        getData()
        setAmountEdit("");
        setOrderEdit("");
        setDateEdit("");
        setCheckID_edit("");
        setRecipientEdit("");
        setSearchBase('');
        setDescriptionEdit("");
        setSearchCheckData("");
        setFilesDataEdit(null)
        setOpenModal(false)

        setNotify({
            isOpen: true,
            message: "Расход успешно изменен!",
            type: "success",
            sound: "success"
        });
        setRender(true)
        setEditRowId_Set(null);
    };

    const onDeleteFile = async (id) => {
        let data = await DeleteFileData(id);
        setNotify({
            isOpen: true,
            message: "Файл успешно удален!",
            type: "success",
            sound: "success"
        });
        setRender(true)
    };
  const [searchCheckData, setSearchCheckData] = useState("");
  const handleCheckChange = (value) => {
    setSearchCheck(value);

    const found = datacheck.find(
      (item) => item.check_data?.toLowerCase() === value.toLowerCase()
    );

    if (found) {
      setSearchCheck(found.id);
      setSearchCheckData(found.check_data); 
      setSearchBase(found.base); 
    } else {
      setSearchCheck('');
    }
  };

  const handleBaseChange = (value) => {
    setSearchBase(value);

    const found = datacheck.find(
      (item) => item.base?.toLowerCase() === value.toLowerCase()
    );

    if (found) {
      setSearchCheck(found.id);
      setSearchCheckData(found.check_data); 
      setSearchBase(found.base); 
    } else {
      setSearchCheck('');
    }
  };


    return (
        <>

            <div className={styles.content_header}>

                <h2 className={styles.project__h}>{t('auto.components_expensescontent.k1')}</h2>
                <button className={styles.btn_print} onClick={handlePrint}>{t('auto.components_academicyearcontent.k1')} </button>


                <Button className={styles.btn_pin} onClick={() => setOpenModal(true)} >
                    Добавить расход
                </Button>
            </div>

            <div className={styles.div_search}>

                <h2 className={styles.project__h}>{t('common.filter')}</h2>
                <div>
                    <div>
                        <input
                            type="text"
                            placeholder={t('auto.components_expensescontent.k5')}
                            value={searchAmount}
                            onChange={(e) => setSearchAmount(e.target.value)}
                        />
                        <input
                            type="text"
                            placeholder={t('auto.components_expensescontent.k6')}
                            value={searchRecipient}
                            onChange={(e) => setSearchRecipient(e.target.value)}
                        />
                        
                        <input
                            type="text"
                            placeholder={t('auto.components_expensescontent.k7')}
                            value={searchOrder}
                            onChange={(e) => setSearchOrder(e.target.value)}
                            style={{ marginRight: '10px' }}
                        />
                        <input
                            type="text"
                            placeholder={t('auto.components_expensescontent.k8')}
                            value={searchDescription}
                            onChange={(e) => setSearchDescription(e.target.value)}
                        />
                    </div>
                    <div>
                        От
                        <input
                            type="date"
                            placeholder={t('auto.components_expensescontent.k9')}
                            value={dateFrom}
                            onChange={(e) => setDateFrom(e.target.value)}
                        />
                        До
                        <input
                            type="date"
                            placeholder={t('auto.components_expensescontent.k10')}
                            value={dateTo}
                            onChange={(e) => setDateTo(e.target.value)}
                        />
                    </div>
                    <Button onClick={clearFilters} className={styles.clear__button} >
                        Очистить
                    </Button>
                </div>
                <div className={styles.div_check_search}>
                    <div>
                        <label>{t('auto.components_checkcontent.k2')}</label>
                        <input
                            type="text"
                            value={searchCheckData}
                            onChange={(e) => handleCheckChange(e.target.value)}
                            list="checkOptions"
                            placeholder={t('auto.components_expensescontent.k11')}
                        />
                        <datalist id="checkOptions">
                            {Array.isArray(datacheck) &&
                                datacheck.map((item) => (
                                    <option key={item.id} value={item.check_data} />
                                ))}
                        </datalist>
                    </div>

                    <div>
                        <label>{t('pages.ordersPage.ground_field')}</label>
                        <input
                            type="text"
                            value={searchBase}
                            onChange={(e) => handleBaseChange(e.target.value)}
                            list="baseOptions"
                            placeholder={t('auto.components_expensescontent.k12')}
                        />
                        <datalist id="baseOptions">
                            {Array.isArray(datacheck) &&
                                datacheck.map((item) => (
                                    <option key={item.id} value={item.base} />
                                ))}
                        </datalist>
                    </div>
                </div>


            </div>

            <table ref={componentRef} className={styles.table__wrapper}>
                <thead className={styles.table__head}>
                    <tr className={styles.table__row}>
                        <th className={styles.table__item}>№</th>
                        <th className={styles.table__item}>
                            <span className={styles.table__title}>{t('dorm.field_amount')}</span>
                        </th>
                        <th className={styles.table__item}>
                            <span className={styles.table__title}>{t('statements.recipient')} </span>
                        </th>
                        <th className={styles.table__item}>
                            <span className={styles.table__title}>{t('auto.components_expensescontent.k2')} </span>
                        </th>

                        <th className={styles.table__item}>
                            <span className={styles.table__title}>{t('auto.components_checkcontent.k5')} </span>
                        </th>
                        <th className={styles.table__item}>
                            <span className={styles.table__title}>{t('pages.ordersPage.ground')} </span>
                        </th>
                        <th className={styles.table__item}>
                            <span className={styles.table__title}>{t('assignments.description_label')}</span>
                        </th>
                        <th className={styles.table__item}>
                            <span className={styles.table__title}>{t('auto.components_expensescontent.k3')}</span>
                        </th>
                        <th className={styles.table__item}>
                            <span className={styles.table__title}>{t('auto.components_expensescontent.k4')}</span>
                        </th>
                        <th className={styles.table__item}>
                            <span className={styles.table__title}>{t('common.file')}</span>
                        </th>
                        <th className={styles.table__item__nav} >
                            <span className={styles.table__title}>{t('common.actions')}</span>
                        </th>
                    </tr>
                </thead>

                <tbody className={styles.table__body}>
                    {currentItems.map((item, index) => (
                        <tr className={styles.table__row} key={item.id}>
                            <td className={styles.table__item}>
                                <span className={styles.table__title}>
                                    {index + 1 + (currentPage - 1) * itemsPerPage}
                                </span>
                            </td>
                            {editRowId === item.id ? (
                                <>
                                    <td className={styles.table__item}>
                                        <input
                                            type="number"
                                            value={amount_edit}
                                            onChange={(e) => setAmountEdit(e.target.value)}
                                            placeholder={t('auto.components_expensescontent.k13')}
                                            className={styles.edit_input}
                                        />
                                    </td>
                                    <td className={styles.table__item}>
                                        <input
                                            type="text"
                                            value={order_edit}
                                            onChange={(e) => setOrderEdit(e.target.value)}
                                            placeholder={t('auto.components_expensescontent.k14')}
                                            className={styles.edit_input}
                                        />
                                    </td>

                                    <td className={styles.table__item}>
                                        <input
                                            type="text"
                                            value={recipient_edit}
                                            onChange={(e) => setRecipientEdit(e.target.value)}
                                            placeholder={t('plagiarism.source')}
                                            className={styles.edit_input}
                                        />
                                    </td>
                                    <td className={styles.table__item}>
                                        <div className={styles.div_check_edit}>
                                            <div>

                                                <select value={selectedCheckId_edit} onChange={(e) => handleSelectCheckByIdEdit(e.target.value)}>
                                                    <option value="">{t('auto.components_checkcontent.k3')}</option>
                                                    {Array.isArray(datacheck) && datacheck.map((item) => (
                                                        <option key={item.id} value={item.id}>
                                                            {item.check_data}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                        </div>
                                    </td>
                                    <td className={styles.table__item}>
                                        <div className={styles.div_check_edit}>

                                            <div>

                                                <select value={selectedCheckId_edit} onChange={(e) => handleSelectCheckByIdEdit(e.target.value)}>

                                                    {Array.isArray(datacheck) && datacheck.map((item) => (
                                                        <option key={item.id} value={item.id}>
                                                            {item.base}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </td>
                                    
                                    <td className={styles.table__item}>
                                        <textarea
                                            value={description_edit}
                                            onChange={(e) => setDescriptionEdit(e.target.value)}
                                            placeholder={t('assignments.description_label')}
                                            className={styles.edit_textarea}
                                        />
                                    </td>
                                    <td className={styles.table__item}>
                                        <input

                                            type="date"
                                            value={date_edit}
                                            onChange={(e) => setDateEdit(e.target.value)}
                                            className={styles.edit_input}
                                        />
                                    </td>
                                    <td className={styles.table__item}>{item.date_сreate}</td>
                                    <td className={styles.table__item}>
                                        <input
                                            type="file"
                                            multiple
                                            onChange={onFileChangeEdit}
                                            id="file-upload"
                                            className={styles.file_upload_input}
                                        />
                                        <label htmlFor="file-upload" className={styles.file_upload_label}>
                                            {files_data_edit?.length ? `Загружено: ${files_data_edit.length}` : 'Загрузите файлы'}
                                        </label>
                                    </td>
                                    <td className={styles.table__item__nav}>
                                        <div className={styles.table__item__div}>
                                            <button onClick={() => onSave(item.id)} className={styles.saveBtn}><Icon name="save" /> </button>
                                            <button onClick={() => setEditRowId_Set(null)} className={styles.cancelBtn}>
                                                <Icon name="close" />
                                            </button>
                                            <button onClick={() => onDelete(item.id)} className={styles.deleteBtn}><Icon name="delete" /></button>
                                        </div>
                                    </td>

                                </>
                            ) : (
                                <>
                                    <td className={styles.table__item}>
                                        <span className={styles.table__title} style={{ fontWeight: '700' }}>
                                            {item.amount}
                                        </span>
                                    </td>
                                    <td className={styles.table__item}>
                                        <span className={styles.table__title}>{item.recipient}</span>
                                    </td>
                                    <td className={styles.table__item}>
                                        <span className={styles.table__title}>{item.order}</span>
                                    </td>
                                    <td className={styles.table__item}>
                                        <span className={styles.table__title}>{item.check}</span>
                                    </td>
                                    <td className={styles.table__item}>
                                        <span className={styles.table__title}>{item.check_base}</span>
                                    </td>
                                    <td className={styles.table__item}>
                                        <span className={styles.table__title}>{item.description}</span>
                                    </td>
                                    <td className={styles.table__item}>
                                        <span className={styles.table__title}>{item.date}</span>
                                    </td>
                                    <td className={styles.table__item}>
                                        <span className={styles.table__title}>{item.date_сreate}</span>
                                    </td>
                                    <td className={styles.table__item}>
                                        <div className={styles.table__fileList}>
                                            {item.documents.map((doc, index) => {
                                                const name = doc.file.split('/').pop();
                                                const short = name.length > 15 ? name.slice(0, 15) + '…' : name;
                                                return (
                                                    <div className={styles.table__fileDiv}>
                                                        <span className={styles.table__title}>
                                                            {index + 1}
                                                        </span>
                                                        <a
                                                            key={index}
                                                            href={doc.file}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className={styles.table__fileButton}

                                                        >
                                                            {short}
                                                        </a>
                                                        <button onClick={() => onDeleteFile(doc.id)} className={styles.deleteBtn}><Icon name="delete" /></button>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </td>
                                    <td className={styles.table__item}>
                                        <div className={styles.table__item__div}>
                                            {/(Отозвано|Аванс|Отпускные|Командировачные|Больничный|Декретный|Почасовые|Зарплата)/i.test(item.description) ? ("") : (
                                                <button onClick={() => setEditRowId(item)} className={styles.editBtn}><Icon name="edit" /> </button>
                                            )}
                                            <button onClick={() => setOpenModalOrderFun(item)} className={styles.editBtn}><Icon name="print" /></button>
                                        </div>
                                    </td>

                                </>
                            )}
                        </tr>
                    ))}

                    
                    <tr className={styles.table__row}>

                        <td className={styles.table__item} style={{ fontWeight: 'bold' }}>
                            Итого: {totalAmount}
                        </td>

                        <td className={styles.table__item}></td>
                        <td className={styles.table__item}></td>
                        <td className={styles.table__item}></td>
                        <td className={styles.table__item}></td>
                        <td className={styles.table__item}></td>
                        <td className={styles.table__item}></td>
                        <td className={styles.table__item}></td>
                        <td className={styles.table__item}></td>
                        <td className={styles.table__item}></td>
                        <td className={styles.table__item}></td>
                    </tr>
                </tbody>
                <div className={styles.pagination} >
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                        <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            style={{
                                padding: '5px 10px',
                                background: currentPage === page ? '#736CED' : '#f0f0f0',
                                color: currentPage === page ? '#fff' : '#000',
                                border: '1px solid #ccc',
                                borderRadius: "6px",
                                cursor: 'pointer',
                            }}
                        >
                            {page}
                        </button>
                    ))}
                </div>


            </table>
            <ModalWindow
                openModal={openModalOrder}
                setOpenModal={setOpenModalOrder}
                modalText={'Расходный ордер'}

            >
                <div  >
                    <ExpensesOrder setOpenModalOrder={setOpenModalOrder} item={item_data} ></ExpensesOrder>
                </div>
            </ModalWindow>
            <ModalWindow
                openModal={openModal}
                setOpenModal={setOpenModal}
                modalText={'Расход'}
            >
                <>
                    <div className={styles["note-input"]}>

                        <form onSubmit={handleSubmit} >
                            <div className={styles.div_check}>
                                <div>
                                    <label>{t('auto.components_checkcontent.k2')}</label>
                                    <input
                                        list="check-options-editnew"
                                        value={searchCheck_editnew}
                                        onChange={(e) => handleCheckInput_editnew(e.target.value)}
                                        placeholder={t('auto.components_expensescontent.k15')}
                                    />
                                    <datalist id="check-options-editnew">
                                        {filteredChecks_editnew?.map(item => (
                                            <option key={item.id} value={item.check_data} />
                                        ))}
                                    </datalist>
                                </div>

                                <div>
                                    <label>{t('pages.ordersPage.ground_field')}</label>
                                    <input
                                        list="base-options-editnew"
                                        value={searchBase_editnew}
                                        onChange={(e) => handleBaseInput_editnew(e.target.value)}
                                        placeholder={t('auto.components_expensescontent.k16')}
                                    />
                                    <datalist id="base-options-editnew">
                                        {filteredBases_editnew?.map(item => (
                                            <option key={item.id} value={item.base} />
                                        ))}
                                    </datalist>
                                </div>
                            </div>
                            <div className={styles.form_input}>
                                <input
                                    type="number"
                                    placeholder={t('auto.components_expensescontent.k17')}

                                    value={amount}
                                    name="amount"
                                    onChange={(e) => setAmount(e.target.value)}
                                />

                                
                                <input
                                    type="text"
                                    placeholder={t('auto.components_expensescontent.k18')}

                                    value={recipient}
                                    name="source"
                                    onChange={(e) => setRecipient(e.target.value)}
                                />
                                <input
                                    type="text"
                                    placeholder={t('auto.components_expensescontent.k19')}

                                    value={order}
                                    name="source"
                                    onChange={(e) => setOrder(e.target.value)}
                                />
                                <input
                                    type="date"
                                    placeholder={t('auto.components_expensescontent.k20')}

                                    value={date}
                                    name="date"
                                    onChange={(e) => setDate(e.target.value)}
                                />

                            </div>

                            <textarea
                                placeholder={t('main.description_placeholder')}

                                value={description}
                                name="description"
                                onChange={(e) => setDescription(e.target.value)}
                            />
                            <div className={styles.add_statement_file}>

                                <input
                                    type="file"
                                    id="file-upload"
                                    multiple
                                    className={styles.file_upload_input}
                                    onChange={onFileChange} 
                                />
                                <label htmlFor="file-upload" className={styles.file_upload_label}>
                                    {files_data ? <> Вы загрузили: {files_data.length} файлов </> : 'Загрузите файлы'}
                                </label>
                            </div>
                            <div className={styles.create_footer}>


                                <button
                                    type="submit"
                                    className={styles.open_btn_sub}

                                >
                                    {t('common.create')}
                                </button>
                            </div>
                        </form>
                    </div>
                    <Button
                        onClick={() => setOpenModal(false)}
                        className={styles.close_btn_sub}
                    >
                        {" "}
                        Закрыть
                    </Button>
                </>
            </ModalWindow>
            <Notification notify={notify} setNotify={setNotify} />


        </>


    );
};

export default ExpensesContent;
